// extracted by css-extract-rspack-plugin
export default {"actionButtons":"ActionButtons-module__actionButtons___xCs9o"};